const $ = jQuery

const submitForm = () => {
  if( !$('.contato').valid() ){ return false; }
  var nome = $('.contato .nome').val();
  var email = $('.contato .email').val();
  var assunto = $('.contato .assunto').val();
  var mensagem = $('.contato .mensagem').val();
  
  $.post( it_.ajaxurl,
    {
      action: 'it_send_email',
      nome: nome,
      email: email,
      assunto: assunto,
      mensagem: mensagem,
    }, ( response ) => {
      if( response.status == 'enviado' ) {
        $('.contato input, .contato textarea').not('.enviar').val('');
        $('#resp').html('E-mail enviado com sucesso').show();
      } else {
        $('#resp').html(response.error).show();
      }
    }
  );
}
  
const validateForm = () => {
  $('.contato').validate({
    rules: {
      nome: { required: true },
      email: {
        required: true,
        email: true
      },
      mensagem: {
        required: true
      }
    },
    messages: {
      nome: 'Por favor, insira seu nome',
      email: 'Por favor, insira um e-mail válido',
      mensagem: 'Por favor, digite sua mensagem'
    },
    errorLabelContainer: $('#resp')
  });
}

( () => {
  $('.contato .enviar').on('click', )
})()